// Short confirmation message (e.g. "Capture saved", "Share link generated
// successfully") — one design for the whole app, styled by .app-toast in
// styles.css. position: 'bottom' (default — centred above the scene's
// bottom bar) or 'top' (centred, just below the header). For 'top',
// `between: [aboveEl, belowEl]` centres it vertically in the
// gap between those two elements (e.g. the header and the first content);
// with only aboveEl it sits TOP_GAP below it. If they don't leave a gap
// (page scrolled), it stays at the CSS default. Fades out after ~2.2 s.
const TOP_GAP = 8;
export function showToast(text, { position = 'bottom', between = null } = {}) {
  const toast = document.createElement('div');
  toast.className = position === 'top' ? 'app-toast app-toast--top' : 'app-toast';
  toast.textContent = text;
  document.body.appendChild(toast);
  if (position === 'top' && between && between[0]) {
    const gapTop = between[0].getBoundingClientRect().bottom;
    if (between[1]) {
      const gapBottom = between[1].getBoundingClientRect().top;
      if (gapBottom > gapTop) {
        toast.style.top = `${Math.round((gapTop + gapBottom) / 2 - toast.offsetHeight / 2)}px`;
      }
    } else if (gapTop >= 0) {
      toast.style.top = `${Math.round(gapTop + TOP_GAP)}px`;
    }
  }
  setTimeout(() => { toast.style.opacity = '0'; }, 2200);
  setTimeout(() => toast.remove(), 2600);
}
